/*******************************************************************************
* Licensed Materials - Property of HCL
* (c) Copyright HCL Technologies Ltd. 2020, 2023. All Rights Reserved.

* Note to U.S. Government Users Restricted Rights:
* Use, duplication or disclosure restricted by GSA ADP Schedule
**************************************************************/

/**
 * Component that displays 3 bubbles with task status
 * required params:
 */

import React from "react";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import { Modal } from "vr-react-components";
import CriticalJobsGraph from "./CriticalJobsGraph";
import CriticalJobsInfoPanel from "./CriticalJobsInfoPanel";
import { setOpenedModal } from "../../store/slice/roomSlice";

const CriticalJobsWidget = ({
    textColor = "#c6c6c6",
    flat = false,
    position,
    width,
    height,
    isClickable,
    ...otherAttributes
}) => {
    const inVRMode = useSelector((state) => state.private.device.inVRMode);
    const canModify = useSelector((state) => state.private.device.canModify);
    const openedModal = useSelector((state) => state.room.openedModal);

    const dispatch = useDispatch();

    const handleSetIsOpened = (id) => dispatch(setOpenedModal(id));

    return isClickable ? (
        <Modal
            id={"critical-modal"}
            position={position}
            width={width}
            height={height}
            aframeClasses={canModify ? "collidable" : ""}
            title="Critical jobs status (by risk)"
            openedPanelDimension={1.15}
            openedPosition="0 1.65 -0.9"
            OpenedComponent={CriticalJobsInfoPanel}
            ClosedComponent={CriticalJobsGraph}
            overlay={!inVRMode}
            openedModal={openedModal}
            onOpen={handleSetIsOpened}
            {...otherAttributes}
        />
    ) : (
        <CriticalJobsGraph
            position={position}
            width={width}
            height={height}
            onOpen={() => { }}
            textSizeDecimal={otherAttributes.textSizeDecimal}
            isNotClickable
        />
    );
};

// requiring dataPoints
CriticalJobsWidget.propTypes = {
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    position: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

export default CriticalJobsWidget;
